export const GetJournalData = async (fileName) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify({ name: fileName })
        };

        const response = await fetch(`${ApiURL}JournalView/text`, requestOptions);

        if (response.status === 200) {
            // Since it returns plain text, we use response.text()
            const textData = await response.text();
            return { success: true, data: textData };
        } else {
            console.error(`API request failed with status code: ${response.status}`);
            return { success: false, data: "" };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: "" };
    }
};



export const GetJournalFiles = async (date) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            // The controller expects an object with a 'DateStr' property; 
            // if your model has `public string DateStr { get; set; }`, do:
            body: JSON.stringify({ date })
        };

        const response = await fetch(`${ApiURL}JournalView/files`, requestOptions);

        if (response.ok) {
            // Since the endpoint returns JSON (array of {label, value}), parse as JSON:
            const responseData = await response.json();
            return { success: true, data: responseData };
        } else {
            console.error(`API request failed with status code: ${response.status}`);
            return { success: false, data: [] };
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
};
